<template>
    <Forms
        ef="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
             v-on:Clear="Clear"
            v-on:Search="Search"
             v-on:Load ="onLoad"
    >

        <div>
            <label class="labelseach bold mt-3">Cliente</label>
                <autocomplete-z ref="ClientePropostaTypeahead"
                        placeholder="Digite um cliente"
                        iconClass="fas fa-user"
                        :serializer="(cliente) => cliente.nome"
                        :debounceLength="2"
                        :formField="SearchItems.cliente"
                        v-on:search="onSearchClienteProposta"
                        v-on:changeCode="onChangeCodeClienteProposta"
                        :ShowCode="false"
                        />

            <label class="labelseach bold mt-3">Corretor</label>
                <autocomplete-z ref="CorretorPropostaTypeahead"
                        placeholder="Digite um corretor"
                        iconClass="fas fa-user"
                        :serializer="(conta) => conta.nome"
                        :debounceLength="2"
                        :formField="SearchItems.conta"
                        v-on:search="onSearchCorretorProposta"
                        v-on:changeCode="onChangeCodeCorretorProposta"
                        :ShowCode="false"
                        />

            <div id="form-seacch">
            <label class="labelseach bold mt-3">Empreendimento</label>
                <select v-model ="SearchItems.empreendimentoId" name="" class="form-control" >
                    <option selected disabled :value="null">Selecione um Empreendimento</option>
                    <option v-for="data in enterprise" v-bind:key="data.id" :value="data.id">{{data.nome}}</option>
                </select>

            <label class="labelseach bold mt-3">Torre/Quadra</label>
                <select v-model ="SearchItems.towerId" name="" class="form-control" ref="tower_blockField" >
                    <option selected disabled :value="null">Selecione a torre ou quadra</option>
                    <option v-for="data in tower" v-bind:key="data" :value="data">{{data}}</option>
                </select>

            <label class="labelseach bold mt-3">Apartamento/Lote</label>
                <select v-model ="SearchItems.apartmentId" name="" class="form-control" ref="apartment_lotField" >
                    <option selected disabled :value="null">Selecione um Apartamento ou Lote</option>
                    <option v-for="data in apartment" v-bind:key="data" :value="data">{{data}}</option>
                </select>

            <div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)">
                <label class="labelseach bold mt-3">Imobiliária</label>
                    <select v-model ="SearchItems.realestateId" name="" ref="realestate_Field" class="form-control" id="" >
                        <option selected disabled :value="null">Selecione uma Imobiliária</option>
                        <option v-for="data in realestate" v-bind:key="data.credenciada.id" :value="data.credenciada.id">{{data.credenciada.nome}}</option>
                    </select>
            </div>

            <!-- <label class="labelseach mt-3">Corretor</label>
                <select v-model ="SearchItems.brokerId" name="" class="form-control" id="" ref="broker_Field">
                    <option selected disabled :value="null">Selecione um corretor</option>
                    <option v-for="data in broker" v-bind:key="data.conta.id" :value="data.conta.id">{{data.conta.nome}}</option>
                </select> -->

            <label class="labelseach bold mt-3">Status</label>
              <select
              name="statusVistoria"
              class="form-control"
              v-model="SearchItems.Status"
              id="exampleFormControlSelect2"
              >
                <option disabled selected :value="''">Selecione o status</option>
                <option v-for="status in StatusSolicitacao" :key="status.value" :value="status.value">{{status.text}}</option>
              </select>

            <label class="labelseach bold mt-3">Período</label>
              <div class="periodos">
                <button id="semanal" class="btn-periodos" v-on:click="semanal" >SEMANAL</button>
                <button id="mensal"  class="btn-periodos" v-on:click="mensal" >MENSAL</button>
                <button id="anual" class="btn-periodos" v-on:click="anual" >ANUAL</button>
                <button id="personalizado" class="btn-periodos" v-on:click="opcoes">PERSONALIZADO</button>
              </div>
              <div class="d-flex align-items-end mt-3" v-if="dataspersonalizadas">
                    <b-form-datepicker
                        ref = "DataInicio"
                        v-model ="SearchItems.DataInicio"
                        placeholder="__/__/__"
                        locale="pt-BR"
                        :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    <label class="labelseach ml-1 mr-1" > à </label>
                    <b-form-datepicker
                        v-model ="SearchItems.DataFinal"
                        placeholder="__/__/__"
                        locale="pt-BR"
                        :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                </div>

            </div>
        </div>
    </Forms>
</template>

<script>

import searchRequests from './searchRequests'
export default searchRequests

</script>

<style scoped>

/* .labelseach{
    font: normal normal normal 16px/21px;
    font-weight: normal;
    font-family: 'Segoe UI';
} */

.bold{
    font-weight: bold;
}

.labelsearch{
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0px;
  font-family: 'Segoe UI';
  /* margin:10px 0; */
}
#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 145px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}
.btn-periodos:focus{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 145px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;

}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/searchRequests/searchRequests.vue